import { PollDayResponse, PollResponse, Issue } from './api.types';

const isPollDayResponse = (
  response: PollDayResponse | PollResponse,
): response is PollDayResponse => {
  return (response as PollDayResponse).data?.issues?.[0]?.progress !== undefined;
};

const addPercentageToIssue = (issue: Issue): Issue => {
  // TODO: type this correctly. This case means vote, not poll
  if (!issue.results?.poll_data) {
    return issue;
  }

  const totalVotes = issue.results.poll_data.yes_votes + issue.results.poll_data.no_votes;
  return {
    ...issue,
    results: {
      ...issue.results,
      poll_data: {
        ...issue.results.poll_data,
        no_votes_percentage: (issue.results.poll_data.no_votes / totalVotes) * 100,
        yes_votes_percentage: (issue.results.poll_data.yes_votes / totalVotes) * 100,
      },
    },
  };
};

const addPercentageToArchiveData = <T>(response: PollDayResponse | PollResponse): T => {
  if (isPollDayResponse(response)) {
    return {
      ...response,
      data: {
        ...response.data,
        issues: response.data.issues.map(addPercentageToIssue),
      },
    } as T;
  }

  const dataWithPercentage = addPercentageToIssue(response.data);

  return {
    data: {
      ...dataWithPercentage,
      info: {
        ...dataWithPercentage.info,
        date: dataWithPercentage.info.date?.replace(
          /(\d{2})\.(\d{2})\.(\d{4})/,
          '$3-$2-$1',
        ),
      },
    },
  } as T;
};

export default addPercentageToArchiveData;
